import React, { Component, Fragment } from "react";

import PasswordResetForm from "../../containers/PasswordResetForm";

class PasswordResetModal extends Component {
  render() {
    return (
      <Fragment>
        <div className="modal__header">
          <span>Connexion</span>
        </div>

        <div className="modal__body">
          <div className="modal__close" onClick={this.props.handleCloseModal}>
            <svg className="bars-icon" viewBox="0 0 24 24">
              <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
            </svg>
          </div>

          <div className="signin-modal pa4 tc">
            <PasswordResetForm />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PasswordResetModal;



// WEBPACK FOOTER //
// ./src/components/modals/PasswordResetModal.js